import { Card, Flex, Form, Typography } from "antd";
import { observer } from "mobx-react-lite";
import { useStores } from "stores";
import { CustomerExecutionModalBody } from "../CustomerExecutionBtn/CustomerExecutionModal/CustomerExecutionModalBody";
import { CheckWalletInput } from "./CheckWalletInput";
import { ConfirmOtpModal } from "components/ConfirmOtpModal";
import { OPERATION_TYPE } from "interfaces";
import { CopyableText, CustomButton, TxButton } from "ui";
import { ItemInfo } from "components";
import { RelevantOperationType } from "services";

type Props = {
  operationPath: RelevantOperationType;
  walletAddress?: string;
  requestId?: string | undefined;
};

export const ApproveDoubleVerificationModal = observer(({ operationPath, walletAddress, requestId }: Props) => {
  const { actionModals, quotes } = useStores();
  const [form] = Form.useForm();
  const lastSymbols = Form.useWatch("lastSymbols", form);

  const disabled =
    (lastSymbols && lastSymbols.length !== walletAddress?.length) || (lastSymbols && lastSymbols.includes("****"));

  const showOtpModalHandler = () => {
    actionModals.open(
      () => (
        <ConfirmOtpModal
          operationPath={operationPath}
          requestBody={{
            fourWalletVerificationSymbols: lastSymbols.slice(-4),
          }}
          requestId={requestId}
          description={
            <Flex vertical gap="large" className="margin-bottom-lg">
              <CustomerExecutionModalBody isExecuteModal={false} showAddressWallet={false} />
              <ItemInfo
                title={"Адрес кошелька"}
                text={<TxButton isWalletAddress text={lastSymbols} />}
                vertical={false}
              />
            </Flex>
          }
          notificationMsg={{
            successMsg: (
              <>
                <Typography.Text className="text-xs text-description">
                  <CopyableText>{walletAddress}</CopyableText>
                </Typography.Text>
                <Typography.Text className="text-xs text-description">успешно подтверждён</Typography.Text>
              </>
            ),
          }}
          cancelBtnProps={{
            position: "bottom",
            title: "Вернуться назад",
            closeHandler: () => actionModals.closeLastModal(),
          }}
          onSuccess={() => setTimeout(() => quotes.fetch(), 1500)}
        />
      ),
      {
        title: "Верификация данных",
        width: "700px",
        onCloseHeader: () => actionModals.closeAll(),
      }
    );
  };

  function closeModalHandler() {
    actionModals.closeAll();
    quotes.setQuoteSelectedId("");
  }

  return (
    <Flex vertical gap="large" className="margin-bottom-lg">
      <CustomerExecutionModalBody isExecuteModal={false} showAddressWallet={false} />
      <Form form={form} name="checkWallet" initialValues={{ lastSymbols: walletAddress }}>
        <CheckWalletInput
          walletAddress={walletAddress}
          maxLength={walletAddress?.length}
          name="lastSymbols"
          title="Для подтверждения адреса кошелька введите его последние 4 символа"
        />
      </Form>

      <Flex gap="small">
        <CustomButton style={{ width: "290px" }} className="full-width" variant="outlined" onClick={closeModalHandler}>
          Отмена
        </CustomButton>
        <CustomButton
          style={{ width: "290px" }}
          onClick={showOtpModalHandler}
          className="full-width"
          disabled={disabled}
          tooltip={disabled ? "Введите последние 4 символа кошелька" : undefined}
        >
          Подтвердить
        </CustomButton>
      </Flex>
    </Flex>
  );
});
